<template>
  <div id="order-summary">
    <h2 class="mb-4 ">Résumé de la commande</h2>
    <v-card color="#f1f1f1" class="mx-auto">
      <v-card-title>{{ order.billing.first_name }} {{ order.billing.last_name }}</v-card-title>
      <v-card-text>
        <v-icon>mdi-at</v-icon>
        {{ order.billing.email }}
      </v-card-text>
      <v-card-text v-if="order.status === 'qrcodeused'">
        <v-icon>mdi-ticket-confirmation</v-icon>
        Les tickets ont déjà été retirés
      </v-card-text>
      <v-card-text v-if="order.status === 'completed'">
        <v-icon>mdi-check-bold</v-icon>
        Le paiement est en ordre
      </v-card-text>
      <v-card-text v-if="['processing', 'on-hold', 'pending'].includes(order.status)">
        <v-icon>mdi-timer-sand</v-icon>
        Le paiement est en attente
      </v-card-text>
      <v-card-text><v-icon>mdi-credit-card-outline</v-icon> {{ order.total }} {{ order.currency_symbol }}</v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ['order']
}
</script>

<style lang="scss" scoped>

</style>
